interface FormatLabels {
  yesLabel: string;
  noLabel: string;
}

const DEFAULT_LABELS: FormatLabels = {
  yesLabel: 'Yes',
  noLabel: 'No',
};

export function formatDisplayValue(value: unknown, labels: FormatLabels = DEFAULT_LABELS): string | null {
  if (value === undefined || value === null || value === '') return null;

  if (typeof value === 'boolean') {
    return value ? labels.yesLabel : labels.noLabel;
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(', ') : null;
  }

  return String(value);
}
